import React from 'react';
import FilterContainer from "./Filters";
import ResultContainer from "./Results";
import SubCategoryContainer from "./SubCategoryContainer";
import SubCategoryFilterContainer from "./SubCategoryFilterContainer";

export default function App(categoryPage) {
    const isCategoryPage = categoryPage.categoryPage;
    return (
        <div className="otc">
            {isCategoryPage === "false" ?
                <div className="otc-listing-wrapper">
                    <FilterContainer />
                    <ResultContainer />
                </div >
                :
                <div className="otc-subcategory-wrapper">
                    <SubCategoryFilterContainer />
                    <SubCategoryContainer />
                </div>
            }
        </div >

    );
}



